import { getStoredSupplierRole } from "@/lib/auth-storage";
import type { AuthContextType } from "@/providers/auth";
import { UserProfileService } from "@/services/user-profile-service";
import {
  type AvailableAgent,
  isAvailableAgent,
} from "@/services/types/agent-gateway";
import { redirect } from "@tanstack/react-router";

export function requireSupplierAdmin(auth: AuthContextType) {
  const supplierRole = auth.user?.supplierRole ?? getStoredSupplierRole();

  if (supplierRole !== "supplier_admin") {
    throw redirect({ to: "/" });
  }
}

export async function requireAgentGatewayAccess(auth: AuthContextType) {
  requireSupplierAdmin(auth);

  const profile = await UserProfileService.getMine();
  if (!profile?.is_agent_gateway_enabled) {
    throw redirect({ to: "/" });
  }
}

export function findAvailableAgent(
  agents: AvailableAgent[] | undefined,
  agentKey: string,
) {
  return agents?.find(
    (agent) => agent.key === agentKey && isAvailableAgent(agent),
  );
}

export function selectAvailableAgent(
  agents: AvailableAgent[],
  requestedAgentKey: string | undefined,
) {
  return agents.find((agent) => agent.key === requestedAgentKey) ?? agents[0];
}
